import React from 'react';
import CustomButton from '../custom-button/custom-button.component';
import FormInput from '../form-input/form-input.component';
import Modal from '../modal/modal.component';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/user/user.selector';
import { sendFormDataStart } from '../../redux/form-trueblue/from-trueblue.actions';
import { checkDigit } from '../../utils/jetBlue-checkDigit';
import {
  SurveyFormContainer,
  SurveyTitle,
  RadioButtonsContainer,
} from './survey-form-trueblue.styles';

class SurveyFormTrueBlue extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      agentName: '',
      customerName: '',
      pnr: '',
      dof: '',
      tbn: '',
      comments: '',
      modalOpen: false,
    };
  }

  toggleModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { agentName, customerName, dof, pnr, tbn, comments } = this.state;
    let first = this.props.currentUser.email.split('.')[0];
    let last = this.props.currentUser.email.split('@')[0].split('.')[1];

    let pnrs = pnr.split(',').filter((p) => p.trim().length !== 6);

    let pnrValid = pnrs.length <= 0;

    if (!pnrValid) {
      alert('Length must be 6 characters for each pnr');
      return;
    }

    if (!checkDigit(tbn)) {
      alert('TrueBlue number is Invlaid');
      return;
    }

    if (
      first.localeCompare(this.state.agentName.split(' ')[0], undefined, {
        sensitivity: 'accent',
      }) === 0 &&
      last.localeCompare(this.state.agentName.split(' ')[1], undefined, {
        sensitivity: 'accent',
      }) === 0
    ) {
      const comment = comments.length === 0 ? 'No comment' : comments;

      this.props.sendFormDataStart({
        agentName,
        customerName,
        dof,
        pnr,
        tbn,
        comment,
      });
      this.toggleModal();
    } else {
      alert('logged in user is different from agent name');
    }
  };

  setValidityMessage = (event) => {
    event.target.setCustomValidity('');
    if (event.target.name === 'tbn') {
      if (!event.target.validity.valid) {
        event.target.setCustomValidity('Lenght must be 10 characters.');
      }
    } else if (event.target.name === 'pnr') {
      if (!event.target.validity.valid) {
        event.target.setCustomValidity(
          'Length must be 6 characters for each pnr'
        );
      }
    }
  };

  handleChange = (event) => {
    const { value, name } = event.target;

    this.setState({ [name]: value });
  };

  render() {
    return (
      <SurveyFormContainer>
        <SurveyTitle>Customer Support TrueBlue Form </SurveyTitle>

        <form onSubmit={this.handleSubmit}>
          <FormInput
            name="agentName"
            type="text"
            handleChange={this.handleChange}
            value={this.state.agentName}
            label="Agent Name"
            className="tb_input"
            required
          />

          <FormInput
            name="customerName"
            type="text"
            handleChange={this.handleChange}
            value={this.state.customerName}
            className="tb_input"
            label="Customer Name"
            required
          />

          <FormInput
            name="pnr"
            type="text"
            minLength="6"
            // maxLength="6"
            handleChange={this.handleChange}
            className="tb_input"
            value={this.state.pnr}
            label="JSX PNR (Enter multiple seperated by commas)"
            onInvalid={this.setValidityMessage}
            required
          />

          <FormInput
            name="dof"
            type="date"
            handleChange={this.handleChange}
            value={this.state.dof}
            label="Todays' Date"
            id="dof"
            required
          />

          <FormInput
            name="tbn"
            type="tel"
            minLength="10"
            maxLength="10"
            id="tbn"
            handleChange={this.handleChange}
            className="tb_input"
            value={this.state.tbn}
            label="TrueBlue #"
            onInvalid={this.setValidityMessage}
            required
          />

          <h6>Any additional comments: </h6>
          <textarea
            id="comments_text_box"
            onChange={this.handleChange}
            value={this.state.comments}
            name="comments"
          />
          <RadioButtonsContainer>
            <CustomButton type="submit"> Submit </CustomButton>
            {/* <CustomButton type="button"> Cancel </CustomButton> */}
          </RadioButtonsContainer>
        </form>

        {this.state.modalOpen && (
          <Modal
            modalOpen={this.state.modalOpen}
            handleClose={this.toggleModal}
            text="Your submission has been recorded!"
            type="dropIn"
          />
        )}
      </SurveyFormContainer>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

const mapDispatchToProps = (dispatch) => ({
  sendFormDataStart: (formData) => dispatch(sendFormDataStart(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyFormTrueBlue);
